import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { ObservationService } from "../../observation/service/observation.service";
import {
  AppDateAdapter,
  APP_DATE_FORMATS,
} from "../date-picker/date-picker.component";
import { UserService } from "../../user/service/user.service";


export interface FormListDependencies {
  form: string;
  dependencies: string[];
}

@Component({
  selector: "app-dialog-filter",
  templateUrl: "./dialog-filter.component.html",
  styleUrls: ["./dialog-filter.component.css"],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
})
export class DialogFilterComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogFilterComponent>,
    private observationService: ObservationService,
    private router: Router,
    private userService: UserService,
    // @Inject(MAT_DIALOG_DATA) public data: DialogData
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  month_selection: { id: string; value: string }[] = [
    { id: '1', value: "Enero" },
    { id: '2', value: "Febrero" },
    { id: '3', value: "Marzo" },
    { id: '4', value: "Abril" },
    { id: '5', value: "Mayo" },
    { id: '6', value: "Junio" },
    { id: '7', value: "Julio" },
    { id: '8', value: "Agosto" },
    { id: '9', value: "Setiembre" },
    { id: '10', value: "Octubre" },
    { id: '11', value: "Noviembre" },
    { id: '12', value: "Diciembre" },
  ];

  formPerson = new FormControl();
  formSite = new FormControl();

  localData!: any;
  _formListDependencies: FormListDependencies[] = [
    {
      form: "fAnyDate",
      dependencies: ["fDate", "fDateInit", "fDateEnd", "fSelected"],
    },
    {
      form: "fDate",
      dependencies: ["fAnyDate", "fDateInit", "fDateEnd", "fSelected"],
    },
    {
      form: "fDateInit",
      dependencies: ["fAnyDate", "fDate", "fSelected"],
    },
    {
      form: "fDateEnd",
      dependencies: ["fAnyDate", "fDate", "fSelected"],
    },
    {
      form: "fSelected",
      dependencies: ["fAnyDate", "fDate", "fDateInit", "fDateEnd"],
    },
  ];

  filteredListPerson!: Observable<
    {
      val: string;
      img: string;
      id: number;
      fn: string;
      ln: string;
    }[]
  >;

  ngOnInit(): void {

    this.localData = {
      p_variety_name: this.data.p_variety_name,
      p_farmer_name: this.data.p_farmer_name,
      p_any_date: this.data.p_any_date,
      p_date_exactly: this.data.p_date_exactly,
      p_date_init: this.data.p_date_init,
      p_date_end: this.data.p_date_end,
      p_month: this.data.p_month,
      p_user_id: this.data.p_user_id,
      p_username: this.data.p_username,
      p_place: this.data.p_place,

      p_country: this.data.p_country,
      p_is_original: this.data.p_is_original,
      p_is_public: this.data.p_is_public,
    };

    this.formPerson.setValue(this.localData.p_username);

    this.formSite.setValue(this.localData.p_place);

    this.filteredListPerson = this.formPerson.valueChanges.pipe(
      startWith(""),
      map((_value) => this.fnSearchPersonNames(_value))
    );
  }

  fnSearchPersonNames(value: string): {
    val: string;
    img: string;
    id: number;
    fn: string;
    ln: string;
  }[] {
    const _optionList: {
      val: string;
      img: string;
      id: number;
      fn: string;
      ln: string;
    }[] = [];

    const _var = {
      page: 0,
      page_size: 1000,
      name: value,
    };
    this.userService.getPagedUsers(_var).subscribe((_result: any) => {
      _result.data.map((_person: any) => {
        _optionList.push({
          val: _person.username,
          img: _person.image_url,
          id: _person.user_id,
          fn: _person.first_name,
          ln: _person.last_name,
        });
      });
    });

    return _optionList;
  }

  fnSelected(form: string, $event: any,) {

    switch (form) {
      case "fDate":
        this.localData.p_date_exactly.setMinutes(this.localData.p_date_exactly.getMinutes() + this.localData.p_date_exactly.getTimezoneOffset());
        break;
      case "fDateInit":
        this.localData.p_date_init.setMinutes(this.localData.p_date_init.getMinutes() + this.localData.p_date_init.getTimezoneOffset());
        break;
      case "fDateEnd":
        this.localData.p_date_end.setMinutes(this.localData.p_date_end.getMinutes() + this.localData.p_date_end.getTimezoneOffset());
        break;
      default:
        break;
    }

    const _removeList = this._formListDependencies.filter(
      (_obj: FormListDependencies) => {
        return _obj.form === form;
      }
    );
    this.fnRemoveInList(_removeList[0]?.dependencies);
  }

  updatePerson() {
    if (this.formPerson.value) {
      const _var = {
        page: 0,
        page_size: 1000,
        name: this.formPerson.value,
      };

      this.userService.getPagedUsers(_var).subscribe((_result: any) => {
        _result.data.map((_person: any) => {
          this.localData.p_user_id = _person?.user_id;
          this.localData.p_username = this.formPerson.value;
        });
      });
    } else {
      this.localData.p_user_id = null;
      this.localData.p_username = null;
    }
  }

  fnRemoveInList(formList: string[]) {
    formList?.map((form) => {
      switch (form) {
        case "fAnyDate":
          this.localData.p_any_date = false;
          break;
        case "fDate":
          this.localData.p_date_exactly = null;
          break;
        case "fDateInit":
          this.localData.p_date_init = null;
          break;
        case "fDateEnd":
          this.localData.p_date_end = null;
          break;
        case "fSelected":
          this.localData.p_month = null;
          break;
        default:
          break;
      }
    });
  }

  fnSearch() {
    this.dialogRef.close(this.localData);


  }
}
